import classNames from 'clsx';
import React, { FC, memo } from 'react';
import { ENABLE_FULL_RESPONSIVE } from 'reactApp/appHelpers/configHelpers';
import { formatAutoDeleteExpires, formatExpiresDropdown } from 'reactApp/utils/formatDate';

import styles from '../DataListItemRow.css';

interface ExpiresProps {
    expires?: number;
    isAutoDelete?: boolean;
    isShared?: boolean;
}

export const Expires: FC<ExpiresProps> = memo(function Expires({ expires, isAutoDelete, isShared }) {
    return (
        <div
            className={classNames({
                [styles.dateResponsive]: ENABLE_FULL_RESPONSIVE,
                [styles.date_wide]: true,
                [styles.expires]: isShared,
                [styles.autodelete]: isAutoDelete,
            })}
        >
            {!!expires &&
                (isAutoDelete
                    ? `Удалится ${formatAutoDeleteExpires(expires, true)}`
                    : isShared && `Доступ открыт до ${formatExpiresDropdown(expires, true)}`)}
        </div>
    );
});
